"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Calculates the actual delay which can be limited by maxInterval */
function getDelay(backoffDelay, maxInterval) {
    return Math.min(backoffDelay, maxInterval);
}
exports.getDelay = getDelay;
/** Exponential backoff delay */
function exponentialBackoffDelay(iteration, initialInterval) {
    return Math.pow(2, iteration) * initialInterval;
}
exports.exponentialBackoffDelay = exponentialBackoffDelay;
